import { render, staticRenderFns } from "./MpButton.vue?vue&type=template&id=0fa4fdcc&scoped=true"
import script from "./MpButton.vue?vue&type=script&lang=js"
export * from "./MpButton.vue?vue&type=script&lang=js"
import style0 from "./MpButton.vue?vue&type=style&index=0&id=0fa4fdcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa4fdcc",
  null
  
)

export default component.exports